var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-nav',{attrs:{"show-menu":false}}),_c('section',{staticClass:"card-body-section"},[_c('div',{staticClass:"gradiant-banner"},[_c('b-container',[_c('h4',{staticClass:"title text-white"},[_vm._v(_vm._s(_vm.title))])])],1),_c('b-container',[_c('div',{staticClass:"card-content"},[_vm._t("default")],2)])],1),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }